import { render, staticRenderFns } from "./Specials.vue?vue&type=template&id=0c2ec6b4&"
import script from "./Specials.vue?vue&type=script&lang=js&"
export * from "./Specials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports